var $e5f3f1b181649fbb$exports = {};
$e5f3f1b181649fbb$exports = {
    "valid": `V\xe1lido`
};


export {$e5f3f1b181649fbb$exports as default};
//# sourceMappingURL=es-ES.module.js.map
